<template>
  <div class="adsense-wrapper">
    <div class="text-xs text-gray-400 text-center mb-1">광고</div>
    <div class="adsense-container">
      <ins class="adsbygoogle"
           :style="adStyle"
           :data-ad-client="adClient"
           :data-ad-slot="adSlot"
           :data-ad-format="adFormat"
           :data-full-width-responsive="fullWidthResponsive"></ins>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue';

const props = defineProps({
  adSlot: {
    type: String,
    required: true
  },
  adFormat: {
    type: String,
    default: 'auto'
  },
  fullWidthResponsive: {
    type: String,
    default: 'true'
  },
  adStyle: {
    type: String,
    default: 'display:block'
  }
});

const adClient = 'ca-pub-6441231653988696';

const adStyle = computed(() => props.adStyle);

onMounted(() => {
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch (e) {
    console.error('AdSense 로드 오류:', e);
  }
});
</script>

<style scoped>
.adsense-wrapper {
  @apply my-4 p-3 bg-gray-50 rounded-lg;
}

.adsense-container {
  @apply min-h-[90px] flex items-center justify-center;
}

.adsbygoogle {
  @apply block;
}
</style>
